import React from 'react';
import { defaultUserPickerStyles } from '@atlassian/jira-base-user-picker/src/styled.tsx';
import GroupPickerEdit from '@atlassian/jira-issue-field-group-picker/src/ui/edit/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { closeMenuOnScroll } from '../../common/utils/select/index.tsx';
import { validateGroupPickerField } from '../../common/utils/validators/index.tsx';
import type { Props, GroupPickerFieldConfig, FieldValue } from './types.tsx';
import { transformGroupDefaultValueToUserOption } from './utils.tsx';

const MultiGroupPickerField = (props: Props) => {
	const {
		width,
		fieldProps: { value, onChange, ...fieldProps },
		fieldId,
		error,
		autoCompleteUrl,
		autoFocus = false,
		isDropdownMenuFixedAndLayered = false,
	} = props;

	const getExtraProps = () => {
		if (isDropdownMenuFixedAndLayered) {
			return {
				menuPosition: 'fixed',
				groupPickerStyles: defaultUserPickerStyles,
				onCloseMenuOnScroll: closeMenuOnScroll,
			} as const;
		}

		return { onCloseMenuOnScroll: closeMenuOnScroll };
	};

	return (
		<FieldContainer width={width}>
			<GroupPickerEdit
				{...fieldProps}
				autoCompleteUrl={autoCompleteUrl}
				onChange={onChange}
				value={value}
				fieldId={fieldId}
				isInvalid={Boolean(error)}
				autoFocus={autoFocus}
				isMulti
				placeholder=" "
				{...getExtraProps()}
			/>
		</FieldContainer>
	);
};

export default withFormField({
	validator: validateGroupPickerField,
	transformDefaultValue: transformGroupDefaultValueToUserOption,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<GroupPickerFieldConfig, LegacyValue<UserPickerOption>>, any>'.
})<GroupPickerFieldConfig, FieldValue>(MultiGroupPickerField);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateMultipleGroupPickerField } from './utils';
